export default {
    userRoleName: {
        participant: "default",
        eventAdmin: "event_admin",
        admin: "admin"
    }
}


// WEBPACK FOOTER //
// ./src/libs/enums.js